import type { IconData } from '@stacksjs/iconify-core'

export const fo1x1: IconData = {
  "body": "<defs><clipPath id=\"SVGMa12rbIW\"><path fill-opacity=\".7\" d=\"M0 0h512v512H0z\"/></clipPath></defs><g fill-rule=\"evenodd\" stroke-width=\"0\" clip-path=\"url(#SVGMa12rbIW)\"><path fill=\"#fff\" d=\"M-78 0h708.2v512H-78z\"/><path fill=\"#003897\" d=\"M-75.9 199.1h198.3V0h113.3v199.1h396.6V313H235.7v199H122.4V312.9H-76z\"/><path fill=\"#d72828\" d=\"M-75.9 227.6h226.6V0h56.7v227.6h424.9v56.9h-425V512h-56.6V284.4H-75.9z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default fo1x1
